export default "__VITE_ASSET__BZqjPco5__"